import { useRef } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import type { AppRole } from "@/lib/roles";

export function RequireAuth({ children, roles }: { children: React.ReactNode; roles?: AppRole[] }) {
  const { session, role, roles: userRoles, loading } = useAuth();
  const loc = useLocation();
  // Once a page has been shown to this user, never swap it for a loading
  // screen during background refreshes (token refresh, tab refocus) — that
  // unmounts the page and wipes in-progress work like a booking.
  const shownFor = useRef<string | null>(null);
  const userId = session?.user?.id ?? null;

  if (loading) {
    if (userId && shownFor.current === userId) return <>{children}</>;
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  }
  if (!session) return <Navigate to={`/auth/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (!role) return <Navigate to="/auth/onboarding" replace />;
  if (roles && !userRoles.includes("founder_owner") && !roles.some((r) => userRoles.includes(r)))
    return <Navigate to="/app" replace />;
  shownFor.current = userId;
  return <>{children}</>;
}
